import { render, staticRenderFns } from "./NVOCCRX.vue?vue&type=template&id=06d332f2&scoped=true&"
import script from "./NVOCCRX.vue?vue&type=script&lang=js&"
export * from "./NVOCCRX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d332f2",
  null
  
)

export default component.exports